import { render } from "./TicketDinamico.vue?vue&type=template&id=1aaa13d2"
import script from "./TicketDinamico.vue?vue&type=script&lang=js"
export * from "./TicketDinamico.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__